module.exports = __webpack_public_path__ + "img/Butterfly_00245.3ae39491.png";